import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Button from "../../components/Button";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import * as actions from "../../actions";

export class ConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.renderButton = this.renderButton.bind(this);
  }

  renderButton(button, index) {
    const { label, type, action, actionFn } = button;

    const click = () => {
      if (actionFn) {
        this.props[actionFn.name].apply(this, actionFn.arguments || []);
        this.props.closeModal();
      } else if (action) {
        this.props.dispatch(action);
        this.props.closeModal();
      }
    };

    return (
      <Button key={index} type={type} onClick={click}>
        {label}
      </Button>
    );
  }

  render() {
    const { title, description, buttons } = this.props;

    return (
      <Modal>
        <ModalHeader>{title}</ModalHeader>
        <ModalContent>
          <p>{description}</p>
        </ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          {buttons.map(this.renderButton)}
        </ModalFooter>
      </Modal>
    );
  }
}

ConfirmModal.propTypes = {
  emailTemplatesList: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  emailTemplates: PropTypes.array,
  gotoUrl: PropTypes.func.isRequired,
  accountId: PropTypes.string,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const title = params.title;
  const description = params.description;
  const buttons = params.buttons;

  return {
    title,
    description,
    buttons,
  };
}

// injects closeModal and dispatch
function mapDispatchToProps(dispatch) {
  return Object.assign(
    {
      dispatch,
      // }, bindActionCreators({ closeModal }, dispatch));
    },
    bindActionCreators(actions, dispatch)
  );
}

// Connect actions
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmModal);
